import React from 'react';
import { database } from '../data/database.ts';

const Ads: React.FC = () => {

  const db = database.ads;

  const featured = database.products.items.find((item) => item.featured);

  return (
    <section id="news" className="news section">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-12" data-aos="fade-up" data-aos-delay="100">
            <div className="news-item">
              <div className="news-overlay">
                <span className="news-title">{db.title}</span>
                <div className="col-xl-3 col-md-6 products" style={{'maxWidth': '270px'}} data-aos="fade-down" data-aos-delay="300">
                  <div className="products-item nopadding">
                    <div className="product-image">
                      <img src={featured?.image} alt="" className="default-image" />
                      <img src={featured?.hoverImage} alt="" className="hover-image" />
                      <span className="product-review">Vista rápida</span>
                    </div>
                    <span className="product-name">{featured?.name}</span>
                    <span className="product-price">{featured?.currency} {featured?.price}.00</span>
                  </div>
                </div>
                
              </div>
              <img className='news-background' src={db.backgroundImage} alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Ads;
